<template>
  <side-base ref="sideBase">
    <div class="swrap">
      <div class="permission-container">
        <div class="tips">
          若需进行机构角色管理，请使用电脑浏览器登录云校电脑端yunxiao.xiaogj.com
        </div>
        <div class="title">手机端权限</div>
        <child
          v-for="item in treeMobile"
          :key="item.id"
          :root="item"
          :toggleList="toggleListMobile"
          @toggle="(...args) => toggle('mobile', ...args)"
        />
        <div class="title">电脑端权限</div>
        <child
          v-for="item in treePc"
          :key="item.id"
          :root="item"
          :toggleList="toggleListPc"
          @toggle="(...args) => toggle('pc', ...args)"
        />
      </div>
      <div class="foot">
        <van-button square round block type="primary" @click.stop="close"> 返回 </van-button>
      </div>
    </div>
  </side-base>
</template>

<script>
import sideMixin from '@x3/js/side/0_mixin/mixin-base.js';
import child from './permission-child.vue';
import transfer from './transfer';

export default {
  mixins: [sideMixin],
  components: {
    child,
  },
  data() {
    return {
      treeMobile: [],
      treePc: [],
      toggleListMobile: [],
      toggleListPc: [],
    };
  },
  methods: {
    toggle(port, id) {
      const list = port === 'mobile' ? this.toggleListMobile : this.toggleListPc;
      if (list.includes(id)) {
        list.splice(
          list.findIndex(item => item === id),
          1
        );
      } else {
        list.push(id);
      }
    },
  },
  created() {
    this.$api
      .getPermission({
        roleId: this.options.id,
      })
      .then(result => {
        this.treeMobile = transfer(result.data.find((item) => item.terminalType === 1).permissionList);
        this.treePc = transfer(result.data.find((item) => item.terminalType === 2).permissionList);
        // 默认展开二级
        this.toggleListMobile = this.treeMobile.map(item=>item.id);
        this.toggleListPc = this.treePc.map(item=>item.id);
      });
  },
};
</script>

<style lang="scss" scoped>
.swrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .permission-container {
    overflow: auto;
    .tips {
      background: var(--white);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      color: var(--g6);
      padding: calc(var(--gap) * 8) calc(var(--gap) * 16);
    }
    .title {
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      color: var(--g6);
      padding: calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 8)
        calc(var(--gap) * 16);
      background: var(--g2);
    }
  }
  .foot {
    background: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    display: flex;
    .van-button {
      height: calc(var(--w) * 40);
    }
  }
}
</style>